import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import get from 'lodash/get';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import {formDataManager} from 'hoc/formDataManager';
import renameStepFormConfig from './renameStepFormConfig';
import {endRenameStepAction} from 'pages/EditBreak/actions';
import {saveResourceFieldAction} from 'resources/actions';
import {extractResourceIdsWithPath} from 'utils/DBUtils';
import RenameStepModal from './RenameStepModal';

const mapStateToProps = state => {
  const {renamingStep} = state.editBreak;
  return {
    data: get(renamingStep, 'step', null),
    stepIndex: get(renamingStep, 'index', -1),
    modalOpen: Boolean(renamingStep)
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  handleClose: endRenameStepAction,
  saveResourceField: saveResourceFieldAction
}, dispatch);

const RenameStepModalConnected = connect(mapStateToProps, mapDispatchToProps);

const RenameStepModalHandlers = withHandlers({
  onSaveData: props => data => {
    const step = props.data;
    const masterBrk = props.formProxy.baseResource["MASTER"];
    const brk = props.formProxy.currentBaseResource;
    const resourceIds = extractResourceIdsWithPath(masterBrk, brk, props.formProxy.resourcePath);

    return props.saveResourceField(
      step.resourceId,
      brk.resourceId,
      [`steps.${props.stepIndex}`],
      [`steps.${props.stepIndex}`, 'internalLabel'],
      'internalLabel',
      data.internalLabel,
      resourceIds.concat(step.resourceId),
      [],
      []
    );
  }
});

const RenameStepModalFormDataManager = formDataManager({
  internalLabel: ''
}, renameStepFormConfig);

const RenameStepModalLifecycle = lifecycle({
  componentWillReceiveProps(nextProps) {
    const modalWillClose = this.props.modalOpen && !nextProps.modalOpen;
    if (modalWillClose) {
      this.props.reset();
    }
  }
});

const RenameStepModalContainer = compose(
  RenameStepModalConnected,
  RenameStepModalHandlers,
  RenameStepModalFormDataManager,
  RenameStepModalLifecycle
)(RenameStepModal);

export default RenameStepModalContainer;



// WEBPACK FOOTER //
// ./public/components/steps/RenameStep/RenameStepModalContainer.js